import { t } from "i18next";
import HelpButton from "./components/pages/auth-pages/HelpButton";
import AuthHeading from "./components/pages/auth-pages/AuthHeading";
import AuthSubHeading from "./components/pages/auth-pages/AuthSubHeading";
import AuthInput from "./components/pages/auth-pages/AuthInput";
import { useEffect, useState } from "react";
import { Button } from "@/components/ui/Button";
import "../../styles/globals.css";
import { useSEO } from "@/contexts/SeoContext";
import { useNavigate } from "react-router-dom";
import routes from "@/config/routes";
import * as yup from "yup";
import { usePasswordResetMutation } from "@/data/user";
import { enqueueSnackbar } from "notistack";

const ResetPasswordV3 = () => {
  const { setTitle, setDescription } = useSEO();
  const navigate = useNavigate();
  const { mutate: reset, isLoading } = usePasswordResetMutation();

  useEffect(() => {
    setTitle("Password Reset");
    setDescription("Enter your email address to reset your password");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [email, setEmail] = useState<string>("");
  const passwordResetValidationSchema = yup.object().shape({
    email: yup
      .string()
      .email(t("auth.errors.valid_email"))
      .required(t("auth.errors.email_required")),
  });

  const onSubmit = (data: { email: string }) => {
    passwordResetValidationSchema
      .validate({ email })
      .then(() => reset(data))
      .catch((error: Error) => {
        enqueueSnackbar({
          message: error.message,
          variant: "error",
          autoHideDuration: 3000,
        });
      });
  };

  return (
    <main className="w-full h-full bg-login-bg flex items-center justify-center md:p-[40px] lg:p-[58px] bg-cover">
      <div className="w-full h-full flex flex-col">
        <div className="flex flex-row justify-end">
          <HelpButton />
        </div>
        <div className="flex h-full flex-col w-full justify-end xl:justify-center items-center">
          <div className="flex flex-col items-center justify-center gap-10">
            <div className="flex flex-col items-center justify-center gap-5">
              <AuthHeading
                text={t("v3.auth.reset_password_header", {
                  defaultValue: "Change your password 🔑",
                })}
              />
              <AuthSubHeading
                text={t("v3.auth.reset_password_sub_header", {
                  defaultValue:
                    "Enter your email address to reset your password",
                })}
              />
            </div>
            <div className="flex flex-col items-center justify-center gap-5">
              <AuthInput
                placeholder="Email address"
                type="email"
                name="login-email"
                handleChange={setEmail}
                regex={/^[^\s@]+@[^\s@]+\.[^\s@]+$/}
              />
            </div>
            <div className="flex w-full flex-row gap-2 md:mt-[25vh] xl:mt-[132px]">
              <Button
                // isLoading={isLoading}
                className="flex flex-auto text-sm text-black bg-white rounded-[10px]  w-full xl:w-[200px] font-semibold h-[30px] hover:bg-white"
                onClick={() => navigate(routes.loginV3)}
                type="button"
              >
                {t("v3.btns.login_back", { defaultValue: "Back to login" })}
              </Button>
              <Button
                disabled={email.length < 1}
                isLoading={isLoading}
                className="flex flex-auto w-full text-sm bg-socials-whatsapp text-black rounded-[10px]  xl:w-[200px] font-semibold h-[30px]  hover:bg-[#21FC93]"
                onClick={() => onSubmit({ email })}
                type="button"
              >
                {t("v3.btns.send", { defaultValue: "Login" })}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default ResetPasswordV3;
